"use client";

import { useMunicipioIndicadoresData } from "@/hooks/useIndicadores";
import React, { createContext, useContext, type ReactNode } from "react";

type MunicipioIndicadoresData = ReturnType<typeof useMunicipioIndicadoresData>;

const IndicadoresContext = createContext<MunicipioIndicadoresData | undefined>(
  undefined
);

export function useMunicipioIndicadores() {
  const ctx = useContext(IndicadoresContext);

  if (!ctx) {
    throw new Error(
      "useMunicipioIndicadores must be used within an IndicadoresProvider"
    );
  }

  return ctx;
}

export function IndicadoresProvider({ children }: { children: ReactNode }) {
  const value = useMunicipioIndicadoresData();

  return (
    <IndicadoresContext.Provider value={value}>
      {children}
    </IndicadoresContext.Provider>
  );
}